import { Injectable } from '@angular/core';
import { TrendDataTime } from '../data/trendings-data';
import { Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AuthenticationServiceService } from './authentication-service.service';
import { CoreModule } from './core.module';
import { globalData } from '../data/general-objects';
import { MqttGeneralInfo, MqttRtData } from '../data/mqtt-system-data';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: CoreModule
})
export class MqttControllerService {

  private Urls = {
    realtime: globalData.restBaseUrl + '/mqtt/realtime/',
    generalInfo: globalData.restBaseUrl + '/mqtt/general_info/',
    trendingStepTime: globalData.restBaseUrl + '/mqtt/trending/stepped_time/',
  };

  constructor(
    private httpClient: HttpClient,
    private authService: AuthenticationServiceService
  ) { }

  /**
   * Obtiene informacion resumida para realtime.
   */
  public GetRealTime(idAplicacion: number, varName?: string): Observable<MqttRtData[]> {
    if (!this.authService.isUserLoggedIn) {
      return null;
    }

    const url = this.Urls.realtime + idAplicacion + '/' + (varName ? varName + '/' : '');

    return this.httpClient.get<MqttRtData[]>(url, this.authService.getStandardHeader()).pipe(
      // tap( data => console.log(data)),
      map ( data => data.map(
        p => new MqttRtData(
          p.idModulo,
          p.variable,
          p.valor,
          p.alarma,
          p.timeout,
          p.valorMin,
          p.valorMax,
          p.valorPromedio,
          p.valorFum,
          p.alarmaFum,
          p.resetEstadisticaFum)
        )
          // , tap( data => console.log(data))
        )
      );
  }

/**
 * Obtiene informacion general de las variables MQTT
 */
public GetGeneralInfo(idAplicacion: number, varName?: string): Observable<MqttGeneralInfo[]> {
  if (!this.authService.isUserLoggedIn) {
    return null;
  }

  const url = this.Urls.generalInfo + idAplicacion + '/' + (varName ? varName + '/' : '');

  return this.httpClient.get<MqttGeneralInfo[]>(url, this.authService.getStandardHeader()).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status == 401) {
        return this.GetGeneralInfo(idAplicacion, varName);
      }
    }),
    map ( data => data.map(
      p => new MqttGeneralInfo(
        p.deviceId,
        p.idAplicacion,
        p.idModulo,
        p.variable,
        p.referencia,
        p.descripcion,
        p.valor,
        p.unidad,
        p.valorFum,
        p.alarma,
        p.alarmaFum,
        p.timeout,
        p.valorMin,
        p.valorMax,
        p.valorPromedio,
        p.resetEstadisticaFum,
        p.barrio,
        p.direccion,
        p.latitud,
        p.longitud,
        p.habTrend,
        p.habAlarma)
        )
        // , tap( data => console.log(data))
      )
    );
  }

/**
 * Obtiene una curva del sistema de trendings del servidor, asociada a una variable
 * @param request Datos de solicitud de trending al server
 */
public GetTrendingSteppedTime(request: TrendDataTime): Observable<TrendDataTime> {

  if (!this.authService.isUserLoggedIn) {
    return null;
  }

  return this.httpClient.post<TrendDataTime>(this.Urls.trendingStepTime, request,
    this.authService.getStandardHeader());
  }
}
